import { apiClient } from './api';

export interface CompanyDoc { id: number; type: string; name: string; issuedAt: string | null; expiresAt: string | null; state: 'valid' | 'expiring' | 'expired' | 'per-bid'; fileName: string }
export interface ChecklistItem { text: string; types: string[]; docs: CompanyDoc[] }

export interface RecordRow {
  documentId: number; fileName: string; title: string; client: string; role: string | null; contractDate: string | null;
  periodStart: string | null; periodEnd: string | null; supplyAmount: number | null; amountText: string;
  inYears: boolean | null; meetsAmount: boolean | null; score: number;
}

/** 제출서류 — 서버 `modules/submission` */
export const submissionApi = {
  /** `dueAt` — 마감(제출 기한). 「마감 전 만료」를 보이는 데 쓴다 */
  checklist: (id: number): Promise<{ items: ChecklistItem[]; companyDocs: CompanyDoc[]; dueAt: string | null }> => apiClient.get(`/projects/${id}/submission`),
  records: (id: number): Promise<{ requirement: { years: number | null; minAmount: number | null; text: string }; records: RecordRow[] }> => apiClient.get(`/projects/${id}/submission/records`),
  recordsTable: (id: number, documentIds: number[]): Promise<{ fileName: string; url: string }> => apiClient.post(`/projects/${id}/submission/records/table`, { documentIds }),
  bundle(id: number, order: string[], files: File[]): Promise<{ fileName: string; url: string; pages: number; warnings: string[] }> {
    const form = new FormData();
    files.forEach((f) => form.append('files', f));
    form.append('order', JSON.stringify(order));
    return apiClient.postForm(`/projects/${id}/submission/bundle`, form);
  },
};
